import { styled, Label as TamaguiLabel } from 'tamagui'

/**
 * Custom Label component that overrides Tamagui's default flex display.
 *
 * Tamagui's default Label has display: 'flex' which causes it to collapse
 * vertically and not reserve proper space in layouts, leading to overlapping
 * with form controls below it.
 *
 * This override adds proper block display, sizing, and spacing to ensure
 * labels properly participate in vertical layout.
 */
export const Label = styled(TamaguiLabel, {
    display: 'block',
    width: '100%',
    fontSize: '$3',         // Consistent body text size
    fontWeight: '500',      // Medium weight for labels
    lineHeight: '$1',       // Proper vertical space for text
    marginBottom: '$2',     // Consistent spacing below label
    color: '$colorMuted',   // Slightly muted for label hierarchy

    variants: {
        // Use when the label sits inline beside a control (e.g. a checkbox) in a
        // centered row. The default block width + bottom margin reserve space below
        // the text, which pushes the text up and leaves the control sitting ~3-4px
        // too low; dropping them lets the label center on the control.
        inline: {
            true: {
                width: 'unset',
                marginBottom: 0,
            },
        },
    } as const,
})
